import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LegalBasisTooltipContent() {
  const learnMoreHref = 'https://knowledge.hubspot.com/contacts/how-can-i-track-lawful-basis-of-processing-in-hubspot';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "options.legalBasis.tooltip.content"
    }), ' ', /*#__PURE__*/_jsx(Link, {
      href: learnMoreHref,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "options.legalBasis.tooltip.learnMore"
      })
    })]
  });
}